


















































import { Component, Vue } from "vue-property-decorator";
import MyPageContentTemplate from "@/components/templates/loggedin/mypage/MyPageContentTemplate.vue";
import PrimaryBtn from "@/components/infrastructures/atoms/designed/PrimaryBtn.vue";
import SubscriptionService from "@/components/domains/payment/shared/subscription/SubscriptionService";

@Component({
  components: {
    MyPageContentTemplate,
    PrimaryBtn
  }
})
export default class SubscriptionState extends Vue {

  name = "SubscriptionState";
  loading = false;

  async openStripePortal() {
    // ユーザー操作直下で window を確保
    const win = window.open("", "_self");
    this.loading = true;
    try {
      const url = await SubscriptionService.fetchManagementUrl();

      // 後から URL を差し替える
      win!.location.href = url;

    } catch (e) {
      alert("Stripe管理画面の取得に失敗しました。")
    } finally {
      this.loading = false;
    }
  }
}
